import { abilitiesPlugin } from '@casl/vue'
import { defineAbility } from '@casl/ability'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ability = defineAbility((can) => {})

export { abilitiesPlugin, ability }
